<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <!-- <div class="flex flex-col space-y-1.5 p-6"> -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Administración de Almacenes
    </h3>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Almacén
    </button>
  </div>

  <div
    class="grow h-full flex items-start p-6 pt-0 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
  >
    <div class="h-full w-full">
      <table class="w-full">
        <thead>
          <tr class="border-b border-border">
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Nombre
            </th>

            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Ubicación
            </th>

            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          @for(warehouse of warehouses; track warehouse.id) {
          <tr class="border-b border-border hover:bg-accent transition-colors">
            <td class="py-4 px-4">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
                >
                  <ng-icon
                    name="lucideWarehouse"
                    class="w-5 h-5 text-secondary-foreground shrink-0"
                  />
                </div>
                <div>
                  <p class="text-foreground font-medium text-xs">
                    {{ warehouse.name }}
                  </p>
                </div>
              </div>
            </td>

            <td class="py-4 px-4 text-muted-foreground text-xs">
              {{ warehouse.location }}
            </td>

            <td class="py-4 px-4 w-1/12">
              <div class="flex items-center space-x-1">
                <button
                  class="ghost sm text-muted-foreground hover:text-foreground"
                  type="button"
                  (click)="updateWarehouse(warehouse)"
                  disabled
                  title="Mover entre almacenes"
                >
                  <ng-icon
                    name="lucideArrowRightLeft"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>

                <button
                  class="ghost sm text-muted-foreground hover:text-foreground"
                  type="button"
                  (click)="updateWarehouse(warehouse)"
                  title="Editar"
                >
                  <ng-icon
                    name="lucidePenLine"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>

                <button
                  class="ghost sm text-destructive"
                  type="button"
                  (click)="deleteWarehouse(warehouse.id)"
                  title="Eliminar"
                >
                  <ng-icon
                    name="lucideTrash2"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-warehouse-form
  [(showModal)]="showModal"
  [existingWarehouse]="existingWarehouse"
></app-warehouse-form>
